(function () {
  'use strict';

  // TOPページ以外では動作しない
  if (!document.querySelector('.home-hero')) return;

  // グループを構成するセクションの内部クラス
  var GROUP_DEFS = [
    ['.home-hero', '.home-new-arrival', '.home-items'],
    ['.home-categories'],
    ['.home-store', '.site-footer']
  ];

  var groups = [];      // { el, spacer, fixedTop } の配列
  var frozenCount = 0;  // 現在fixedになっているグループ数

  // 内部クラスからShopifyのセクションラッパーを取得
  function getWrapper(sel) {
    var inner = document.querySelector(sel);
    if (!inner) return null;
    return inner.closest('.shopify-section-group') || inner.closest('.shopify-section');
  }

  // 各グループをラップ要素でまとめる
  function buildGroups() {
    GROUP_DEFS.forEach(function (selectors, i) {
      var elements = selectors.map(getWrapper).filter(Boolean);
      if (!elements.length) return;

      // ラッパーを作成
      var wrapper = document.createElement('div');
      wrapper.className = 'scroll-stack-group scroll-stack-group--' + (i + 1);

      // スペーサー（fixed化後に高さを保持するための空div）
      var spacer = document.createElement('div');
      spacer.style.display = 'none';

      elements[0].parentNode.insertBefore(wrapper, elements[0]);
      elements[0].parentNode.insertBefore(spacer, wrapper.nextSibling);
      elements.forEach(function (el) { wrapper.appendChild(el); });

      groups.push({ el: wrapper, spacer: spacer, fixedTop: 0 });
    });
  }

  // グループをfixedに固定する（視覚的な位置を維持）
  function freezeGroup(group) {
    var rect = group.el.getBoundingClientRect();
    group.fixedTop = rect.top + window.scrollY; // ドキュメント上の絶対位置
    group.frozenViewportTop = rect.top;          // 固定時のビューポート上の位置

    // スペーサーで高さを確保（レイアウトを崩さない）
    group.spacer.style.display = 'block';
    group.spacer.style.height = group.el.offsetHeight + 'px';

    // 現在の視覚位置を維持したままfixed化
    group.el.classList.add('scroll-stack-group--fixed');
    group.el.style.top = rect.top + 'px';
  }

  // fixedを解除する
  function unfreezeGroup(group) {
    group.el.classList.remove('scroll-stack-group--fixed');
    group.el.style.top = '';
    group.spacer.style.display = 'none';
  }

  // スクロールに応じてfrozenCountを更新
  function onScroll() {
    var scrollBottom = window.scrollY + window.innerHeight;

    // 下スクロール：グループの末尾に到達したらfixedに
    for (var i = frozenCount; i < groups.length - 1; i++) {
      var group = groups[i];
      var groupBottom = group.el.classList.contains('scroll-stack-group--fixed')
        ? group.fixedTop + group.el.offsetHeight
        : group.el.getBoundingClientRect().bottom + window.scrollY;

      if (scrollBottom >= groupBottom) {
        freezeGroup(group);
        frozenCount = i + 1;
      } else {
        break;
      }
    }

    // 上スクロール：グループの末尾より上に戻ったらfixedを解除
    for (var j = frozenCount - 1; j >= 0; j--) {
      var g = groups[j];
      var gBottom = g.fixedTop + g.el.offsetHeight;

      if (scrollBottom < gBottom) {
        unfreezeGroup(g);
        frozenCount = j;
      } else {
        break;
      }
    }
  }

  function init() {
    buildGroups();
    if (!groups.length) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // 初期チェック
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
